var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.143555,
    y: 0.625,
    width: 50,
    height: 50,
    rx: 8.75,
    fill: "#1EBFB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4287 13C16.4287 11.375 17.7412 10 19.4287 10H29.4287C31.0537 10 32.4287 11.375 32.4287 13H16.4287ZM32.4287 39C32.4287 40.6875 31.0537 42 29.4287 42H19.4287C17.7412 42 16.4287 40.6875 16.4287 39H32.4287ZM12.4287 20C12.4287 17.25 14.6162 15 17.4287 15H31.4287C34.1787 15 36.4287 17.25 36.4287 20V32C36.4287 34.8125 34.1787 37 31.4287 37H17.4287C14.6162 37 12.4287 34.8125 12.4287 32V20ZM18.6787 26.5625L23.6787 31.375C24.1162 31.75 24.6787 31.75 25.1162 31.375L30.1162 26.5625C31.3662 25.3125 31.3662 23.3125 30.1162 22.0625C28.9287 20.9375 26.9912 20.9375 25.8037 22.0625L24.4287 23.4375L22.9912 22.0625C21.8037 20.9375 19.8662 20.9375 18.6787 22.0625C17.4287 23.3125 17.4287 25.3125 18.6787 26.5625Z",
    fill: "#83DFD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.b2a32bfa.svg";
export { ForwardRef as ReactComponent };